export const ActionType = Object.freeze({
	Add: 'Add',
	Click: 'Click',
	Delete: 'Delete', // trash icon or 'X' tool button
	Edit: 'Edit',
	Search: 'Search',
	Settings: 'Settings',
});
